import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';

import actions from 'state/direct-order/shipments/actionCreators';
import initialState from 'state/direct-order/shipments/initial.state';

const shipments = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setShipmentKeys]: (state, { payload: { shipmentKeys } }) => [
      ...shipmentKeys,
    ],
  },
  initialState
);

export default shipments;
